import {
  FIELD_MEMBERS,
  FIELD_SET_COMMON_PAY_FREQUENCY,
  FIELD_GROUP_BUTTONS,
  FIELD_MEMBER_SELECTED,
  WAGES_AND_INCOME_COMMON_FIELD_NAMES,
} from './constants.fields';
import { getMemberKey } from 'pages/AffordaHousehold/utils';
import { FormattedMessage } from 'react-intl';

export const PENSION_FIELD_NAMES = {
  id: WAGES_AND_INCOME_COMMON_FIELD_NAMES.id,
  annualAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.annualAmount,
  memberId: WAGES_AND_INCOME_COMMON_FIELD_NAMES.memberId,
  monthlyAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.monthlyAmount,
  payFrequency: WAGES_AND_INCOME_COMMON_FIELD_NAMES.payFrequency,
  source: WAGES_AND_INCOME_COMMON_FIELD_NAMES.source,
  weeklyAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.weeklyAmount,
};

export const NEW_PENSION = {
  [PENSION_FIELD_NAMES.annualAmount]: '',
  [PENSION_FIELD_NAMES.memberId]: '',
  [PENSION_FIELD_NAMES.monthlyAmount]: '',
  [PENSION_FIELD_NAMES.payFrequency]: '',
  [PENSION_FIELD_NAMES.source]: '',
  [PENSION_FIELD_NAMES.weeklyAmount]: '',
};

export const MESSAGE_IDS = {
  title: 'afforda.wagesAndIncome.details.pension.title',
  description: 'afforda.wagesAndIncome.details.pension.subtitle',
  addButton: 'afforda.wagesAndIncome.details.pension.add',
  addCaption: 'afforda.wagesAndIncome.details.pension.addDescription',
};

export const getDefaultValues = (item) => {
  return {
    ...item,
    id: item.id,
    annualAmount: item.annualAmount ?? '',
    monthlyAmount: item.monthlyAmount ?? '',
    payFrequency: item.payFrequency ?? '',
    source: item.source ?? '',
    weeklyAmount: item.weeklyAmount ?? '',
  };
};

export const getFormProps = ({ items, members, memberId }) => {
  const disabledMembers =
    members
      ?.filter((member) => {
        const memberKey = getMemberKey(member);
        // If the member already has all pension sources, disable them
        return Object.values(PENSION_SOURCES).every((src) =>
          items.some(
            (item) => item.memberId === memberKey && item.source === src,
          ),
        );
      })
      ?.map(({ id }) => id) ?? [];

  const itemsExceptLast = items.slice(0, items.length - 1);
  const disabledCurrentSources = Object.values(PENSION_SOURCES).filter(
    (source) =>
      itemsExceptLast.some(
        (record) => record?.memberId === memberId && record.source === source,
      ),
  );

  return {
    disabledMembers,
    disabledCurrentSources,
  };
};

export const getIsAddDisabled = ({ items, members, memberId }) => {
  const membersAvailable =
    members?.filter((member) => {
      // For the current user, see if all sources are used
      const hasAllSources = Object.values(PENSION_SOURCES).every((src) =>
        items.some(
          (record) => record?.memberId === memberId && record.source === src,
        ),
      );
      return !hasAllSources;
    }) ?? [];

  return membersAvailable.length > 0;
};

export const PENSION_SOURCES = {
  PENSION: 'pension',
  ANNUITY: 'annuity',
  RETIREMENT: 'retirement',
  INSURANCE: 'insurance',
  DEATH: 'death',
};

export const PENSION_SOURCE_OPTIONS = {
  SOURCE_PENSION: {
    value: PENSION_SOURCES.PENSION,
    text: `afforda.wagesAndIncome.details.pension.source.${PENSION_SOURCES.PENSION}`,
  },
  SOURCE_ANNUITY: {
    value: PENSION_SOURCES.ANNUITY,
    text: `afforda.wagesAndIncome.details.pension.source.${PENSION_SOURCES.ANNUITY}`,
  },
  SOURCE_RETIREMENT: {
    value: PENSION_SOURCES.RETIREMENT,
    text: `afforda.wagesAndIncome.details.pension.source.${PENSION_SOURCES.RETIREMENT}`,
  },
  SOURCE_INSURANCE: {
    value: PENSION_SOURCES.INSURANCE,
    text: `afforda.wagesAndIncome.details.pension.source.${PENSION_SOURCES.INSURANCE}`,
  },
  SOURCE_DEATH: {
    value: PENSION_SOURCES.DEATH,
    text: `afforda.wagesAndIncome.details.pension.source.${PENSION_SOURCES.DEATH}`,
  },
};

export const FIELDS = ({
  members,
  disabledMembers,
  disabledCurrentSources,
}) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    {
      ...FIELD_GROUP_BUTTONS,
      ...FIELD_MEMBER_SELECTED,
      label: <FormattedMessage id="afforda.wagesAndIncome.details.source" />,
      name: PENSION_FIELD_NAMES.source,
      rules: {
        required: true,
      },
      GridProps: {
        xs: 12,
      },
      direction: 'row',
      options: Object.values(PENSION_SOURCE_OPTIONS)?.map((option) => ({
        value: option.value,
        label: <FormattedMessage id={option.text} />,
        disabled: disabledCurrentSources.includes(option.value),
      })),
    },
    // Pay Frequency
    ...FIELD_SET_COMMON_PAY_FREQUENCY,
  ];
};
